//  const webap_url = "https://npgapp002-dfabaxcvgxadgsem.uksouth-01.azurewebsites.net";
// const webap_url = "https://npgwfm.cyient.com";
 const webap_url = "/test";
 const react_loging = 'azure';
 const redirect_url = 'https://npgwfm.cyient.com/viewtasks';

// const webap_url = "http://localhost:4051"
// const react_loging = 'local';
// const redirect_url = 'http://localhost:3000/viewtasks';

// const webap_url = process.env.NODE_ENV === 'production'
//   ? process.env.REACT_APP_API_URL
//   : ''; // use relative URL in dev

const config = {
  react_loging: {
    react_Login_With_url: `${react_loging}`
  },
  Redirect: {
    redirect_url: `${redirect_url}`,
  },
  Login: {
    LoginURL: `${webap_url}/api/security/Login`,
  },
  DatabaceConnection: {
    URL: `${webap_url}/dbconnection_check`,
  },
  EmailRequest: {
    url: `${webap_url}/send-email_azure`
  },
  EmailRequestEvents: {
    url: `${webap_url}/email-events`
  },
  DownloadFile: {
    url: `${webap_url}/api/data/export-csv`
  },
  GetExistingvalue: {
    url: `${webap_url}/api/data/Existingvalue`,
  },
  ProcessQuery: {
    url: `${webap_url}/api/data/ProcessQuery`,
  },
  UpLoadFile: {
    url: `${webap_url}/api/uploadjobs/UploadFile`,
  },
  UpdateJobs: {
    url: `${webap_url}/api/data/UpdateData`,
  },
  DeleteJobs: {
    url: `${webap_url}/api/data/DeleteData`,
  },
  UpdateTimesheet: {
    url: `${webap_url}/api/data/UpdateTimesheet`,
  },
  InsertData: {
    url: `${webap_url}/api/data/InsertData`,
  },
  ProcessQueryWitVals: {
    url: `${webap_url}/api/data/ProcessQueryWithVals`,
  },
  ProcessQueryWitJSON: {
    url: `${webap_url}/api/data/ProcessQueryWithJSON`,
  },

  UpdateDatawithfunction: {
    url: `${webap_url}/api/data/UpdateDatawithfunction`,
  },
  TaskProcessQueryWithVals: {
    url: `${webap_url}/api/data/TaskProcessQueryWithVals`,
  },

  UploadJobsFromJSON: {
    url: `${webap_url}/api/uploadjobs/UploadJobsFromJSON`,
  },
  ProcessDataTableQuery: {
    url: `${webap_url}/api/data/ProcessDataTableQuery`,
  },
  ProcessDataTable: {
    url: `${webap_url}/api/data/ProcessDataTable`,
  },
  ProcessDataTableQueryStreamData: {
    url: `${webap_url}/api/data/ProcessDataTableQueryStreamData`,
  },
  ProcessQueryCursor: {
    url: `${webap_url}/api/data/ProcessQueryCursor`,
  },
  ProductivityPercMax: 1000,
  DataEntryColumnOrder: `Asbuilt (Y/N),Lat,Long,ERP ID,Location/Parent Feature,Location/Parent Feature ID,Feature,Feature ID (GESW),Input Status,Tool Output Result,Final Status`,

  UploadLocalfiles: {
    url: `${webap_url}/uploads/`,
  },
  UpdateTabels: {
    url: `${webap_url}/api/data/updatetables`,
  },
  TableColumns: {
    Viewdocuments: `document_id,document_name,document_type,document_type,activity_ref,construction_date,received_date,ehv_cable,hv_cable,lv_cable,aux,no_of_services,volume_services,plant,supports,document_path,status,job_id,job_title,created_date,task_id,job_status,original_document_name,username,username,comments,created_date1,received_date1,construction_date1,contractor_name,contractor_id`,
  },
  DisplayColumns: {
    Viewdocuments: `document_id,document_name,document_type,document_type,activity_ref,construction_date,received_date`,
  },
};
export default config;